import { SELECTED_TERMS } from '../../constants';
import { redirectToURL } from './redirectToTermsURL';
export var openTermsAndConditionsByURL = function openTermsAndConditionsByURL(props) {
  var userProperty = props.userProperty,
      propertySelector = props.propertySelector,
      selectedTerms = props.item;
  var property = propertySelector.find(function (property) {
    return property.propertyId == userProperty;
  });

  if (property && (!property.termsAndConditionsURL.endsWith('.md') || !property.privacyPolicyURL.endsWith('.md'))) {
    if (selectedTerms === SELECTED_TERMS.TERMS) redirectToURL(property.termsAndConditionsURL);else if (selectedTerms === SELECTED_TERMS.PRIVACY) redirectToURL(property.privacyPolicyURL);
    return true;
  } else return false;
};